@if (showApp) {
  <app-main-page />
}